var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarProfilePhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4177_219019)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.708,
    y: 4.01855,
    width: 153.539,
    height: 153.539,
    rx: 76.7695,
    fill: "#F9F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.067 109.576V103.179C118.067 99.7852 116.719 96.5308 114.32 94.1313C111.92 91.7318 108.666 90.3837 105.272 90.3837H79.6826C76.2892 90.3837 73.0347 91.7318 70.6352 94.1313C68.2357 96.5308 66.8877 99.7852 66.8877 103.179V109.576M105.272 64.7939C105.272 71.8604 99.5439 77.5888 92.4775 77.5888C85.4111 77.5888 79.6826 71.8604 79.6826 64.7939C79.6826 57.7275 85.4111 51.999 92.4775 51.999C99.5439 51.999 105.272 57.7275 105.272 64.7939Z",
    stroke: "#7F56D9",
    strokeWidth: 6.39745,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7888,
    y: 2.09932,
    width: 157.377,
    height: 157.377,
    rx: 78.6887,
    stroke: "white",
    strokeWidth: 3.83847
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4177_219019",
    x: 0.353723,
    y: 0.179687,
    width: 184.247,
    height: 184.247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.91924,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4177_219019"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.83847
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.87885
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4177_219019"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.83847,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4177_219019"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.5154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.67695
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4177_219019",
    result: "effect2_dropShadow_4177_219019"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4177_219019",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarProfilePhoto);
export default __webpack_public_path__ + "static/media/avatar-profile-photo.827b14b2abccc089fbd3d4152a0ffe25.svg";
export { ForwardRef as ReactComponent };